var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityNotificationSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4626 23.1601L26.1887 22.9184C25.4119 22.2259 24.7318 21.4321 24.1668 20.5582C23.5493 19.3521 23.1795 18.0347 23.0793 16.6834V12.704C23.0846 10.5818 22.3148 8.53079 20.9145 6.93619C19.5142 5.34159 17.5799 4.31321 15.4748 4.04427V3.0051C15.4748 2.71989 15.3615 2.44635 15.1598 2.24467C14.9581 2.04299 14.6846 1.92969 14.3994 1.92969C14.1142 1.92969 13.8406 2.04299 13.639 2.24467C13.4373 2.44635 13.324 2.71989 13.324 3.0051V4.06038C11.2378 4.34871 9.32679 5.38331 7.9449 6.97255C6.56302 8.56179 5.8039 10.598 5.80814 12.704V16.6834C5.70789 18.0347 5.33813 19.3521 4.72064 20.5582C4.16552 21.4301 3.49635 22.2238 2.73092 22.9184L2.45703 23.1601V25.4318H26.4626V23.1601Z",
    fill: "#4D4D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3418 26.2773C12.4124 26.788 12.6655 27.2558 13.0541 27.5944C13.4428 27.933 13.9409 28.1195 14.4564 28.1195C14.9719 28.1195 15.4699 27.933 15.8586 27.5944C16.2473 27.2558 16.5003 26.788 16.571 26.2773H12.3418Z",
    fill: "#4D4D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityNotificationSolid);
export default __webpack_public_path__ + "static/media/clarity_notification-solid.205d6c7167cd8df67c73ce91f418bd2f.svg";
export { ForwardRef as ReactComponent };